/* FÉNIX 2.4 V23 HOME FOOTER 01 · nm-fenix-r07-screenshot-qa-v58.js */
/* FÉNIX R07.58 — concise hero plaque copy */
(function(){
  function refine(){
    var plaque=document.querySelector('body.template-index .fnx-c02-stage__meta');
    if(!plaque) return;
    var title=plaque.querySelector('strong');
    if(title) title.textContent='Noopept · 30 mg · 60 píldoras';
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',refine,{once:true});
  else refine();
})();
;

/* FÉNIX 2.4 V23 HOME FOOTER 02 · nm-fenix-r07-luminous-interface-v61.js */
/* FÉNIX R07.63 · pointer-light: halo cinematográfico solo en puntero fino. */
(function(){
  var hero=document.querySelector('.fnx-c02-hero');
  if(!hero)return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  if(!window.matchMedia('(hover: hover) and (pointer: fine)').matches)return;

  var frame=0;
  function paint(e){
    if(frame)cancelAnimationFrame(frame);
    frame=requestAnimationFrame(function(){
      var r=hero.getBoundingClientRect();
      var x=Math.max(28,Math.min(82,((e.clientX-r.left)/r.width)*100));
      var y=Math.max(24,Math.min(74,((e.clientY-r.top)/r.height)*100));
      hero.style.setProperty('--fnx61-x',x.toFixed(1)+'%');
      hero.style.setProperty('--fnx61-y',y.toFixed(1)+'%');
    });
  }

  hero.addEventListener('pointermove',paint,{passive:true});
  hero.addEventListener('pointerleave',function(){
    hero.style.setProperty('--fnx61-x','60%');
    hero.style.setProperty('--fnx61-y','45%');
  },{passive:true});
})();
;

/* FÉNIX 2.4 V23 HOME FOOTER 03 · nm-fenix-r07-mvv-side-dock-v66.js */
/* FÉNIX R07.70 · MVV FLANK SELECTOR · image-only alternates */
(function(){
  'use strict';
  function init(){
    var home=document.querySelector('[data-fnx-c02-home]');
    if(!home||home.dataset.r70Ready==='1')return;
    var stage=home.querySelector('.fnx-c02-stage');
    if(!stage)return;
    var slides=Array.prototype.slice.call(stage.querySelectorAll('[data-fnx-r70-stage]'));
    var choices=Array.prototype.slice.call(stage.querySelectorAll('[data-fnx-r70-choice]'));
    var meta=stage.querySelector('[data-fnx-r70-meta]');
    var metaKicker=meta&&meta.querySelector('[data-fnx-r70-meta-kicker]');
    var metaTitle=meta&&meta.querySelector('[data-fnx-r70-meta-title]');
    var metaPrice=meta&&meta.querySelector('[data-fnx-r70-meta-price]');
    var live=stage.querySelector('[data-fnx-r70-live]');
    if(slides.length<2)return;
    var order=slides.map(function(slide){return slide.getAttribute('data-fnx-r70-stage');});
    var activeIndex=0;
    function choiceFor(key){return choices.find(function(choice){return choice.getAttribute('data-fnx-r70-choice')===key;});}
    function activate(key,announce){
      var index=order.indexOf(key);if(index<0)return;activeIndex=index;
      slides.forEach(function(slide,i){var on=i===index;slide.classList.toggle('is-active',on);slide.setAttribute('aria-hidden',on?'false':'true');if(on)slide.removeAttribute('tabindex');else slide.setAttribute('tabindex','-1');});
      choices.forEach(function(choice){var on=choice.getAttribute('data-fnx-r70-choice')===key;choice.classList.toggle('is-current',on);choice.classList.remove('is-left','is-right');choice.setAttribute('aria-pressed',on?'true':'false');choice.setAttribute('aria-hidden',on?'true':'false');if(on)choice.setAttribute('tabindex','-1');else choice.removeAttribute('tabindex');});
      var leftKey=order[(index-1+order.length)%order.length];var rightKey=order[(index+1)%order.length];var left=choiceFor(leftKey);var right=choiceFor(rightKey);if(left)left.classList.add('is-left');if(right)right.classList.add('is-right');
      var slide=slides[index];var title=slide.getAttribute('data-fnx-r70-title')||'Producto destacado';var price=slide.getAttribute('data-fnx-r70-price')||'';var vendor=slide.getAttribute('data-fnx-r70-vendor')||'';var href=slide.getAttribute('href')||'#';
      if(meta){meta.setAttribute('href',href);meta.setAttribute('aria-label','Ver '+title);}if(metaKicker)metaKicker.textContent='MVV · '+vendor.toUpperCase();if(metaTitle)metaTitle.textContent=title;if(metaPrice)metaPrice.textContent=price;if(live&&announce)live.textContent=title+', '+price;home.setAttribute('data-fnx-r70-active',key);
    }
    function step(delta,announce){activate(order[(activeIndex+delta+order.length)%order.length],announce);}
    choices.forEach(function(choice){choice.addEventListener('click',function(){activate(choice.getAttribute('data-fnx-r70-choice'),true);});});
    stage.addEventListener('keydown',function(event){if(event.key==='ArrowLeft'){event.preventDefault();step(-1,true);}else if(event.key==='ArrowRight'){event.preventDefault();step(1,true);}});
    var touchStart=null;
    stage.addEventListener('touchstart',function(event){var touch=event.changedTouches&&event.changedTouches[0];if(touch)touchStart={x:touch.clientX,y:touch.clientY};},{passive:true});
    stage.addEventListener('touchend',function(event){if(!touchStart)return;var touch=event.changedTouches&&event.changedTouches[0];if(!touch){touchStart=null;return;}var dx=touch.clientX-touchStart.x;var dy=touch.clientY-touchStart.y;touchStart=null;if(Math.abs(dx)<44||Math.abs(dx)<=Math.abs(dy)*1.15)return;step(dx<0?1:-1,true);},{passive:true});
    home.dataset.r70Ready='1';home.classList.add('fnx-r70-ready');stage.classList.add('fnx-r64-stage-ready','fnx-r70-stage-ready');activate(order[0],false);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
;

/* FÉNIX 2.4 V23 HOME FOOTER 04 · nm-fenix-r07-mobile-rhythm-v72.js */
/* FÉNIX R07.72 — compact runtime guard: FAB + mobile/touch state. */
(function(){
  'use strict';
  function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn,{once:true});else fn();}
  ready(function(){
    var body=document.body;
    var footer=document.querySelector('footer.site-footer');
    var nav=document.getElementById('MobileNav');
    var fab=document.querySelector('.nm-chat-fab');
    if(!body)return;

    function isCompact(){
      var narrow=window.matchMedia&&window.matchMedia('(max-width:760px)').matches;
      var coarse=window.matchMedia&&window.matchMedia('(max-width:1180px) and (hover:none) and (pointer:coarse)').matches;
      return !!(narrow||coarse);
    }

    function syncCompact(){body.classList.toggle('nm-r072-compact',isCompact());}
    syncCompact();
    window.addEventListener('resize',syncCompact,{passive:true});

    var footerHit=false;
    var menuOpen=false;
    function syncFab(){
      body.classList.toggle('nm-r072-fab-footer',!!footerHit&&isCompact());
      body.classList.toggle('nm-r072-menu-open',!!menuOpen&&isCompact());
      if(fab){
        var hidden=isCompact()&&(footerHit||menuOpen);
        if(hidden){fab.setAttribute('aria-hidden','true');fab.setAttribute('tabindex','-1');}
        else{fab.removeAttribute('aria-hidden');fab.removeAttribute('tabindex');}
      }
    }

    if(footer&&'IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){
        footerHit=!!(entries[0]&&entries[0].isIntersecting);
        syncFab();
      },{root:null,rootMargin:'0px 0px 44px 0px',threshold:0});
      io.observe(footer);
    }

    function readMenu(){
      menuOpen=!!(nav&&nav.classList.contains('is-visible'));
      syncFab();
    }
    if(nav&&'MutationObserver' in window){
      new MutationObserver(readMenu).observe(nav,{attributes:true,attributeFilter:['class']});
      readMenu();
    }else{
      syncFab();
    }
  });
})();
;

/* FÉNIX 2.4 V23 HOME FOOTER 05 · nm-fenix-r07-iphone-closure-v73.js */
/* FÉNIX R07.73 — viewport/touch runtime authority. */
(function(){
  'use strict';
  function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn,{once:true});else fn();}
  ready(function(){
    var root=document.documentElement;
    var body=document.body;
    if(!root||!body)return;

    function viewportWidth(){
      var values=[];
      if(window.innerWidth>0)values.push(window.innerWidth);
      if(document.documentElement.clientWidth>0)values.push(document.documentElement.clientWidth);
      if(window.visualViewport&&window.visualViewport.width>0)values.push(window.visualViewport.width);
      if(window.screen&&window.screen.width>0)values.push(window.screen.width);
      return values.length?Math.min.apply(Math,values):window.innerWidth;
    }
    function isTouch(){return (navigator.maxTouchPoints||0)>0||(window.matchMedia&&window.matchMedia('(pointer:coarse)').matches);}
    function syncViewport(){
      var w=Math.max(280,Math.round(viewportWidth()));
      var compact=w<=820||(isTouch()&&w<=1180);
      body.classList.toggle('nm-r073-compact',compact);
      root.style.setProperty('--nm-r073-vw',w+'px');
      syncContext();
    }

    var targets=[];
    var visible=new Set();
    function syncContext(){body.classList.toggle('nm-r073-fab-context',body.classList.contains('nm-r073-compact')&&visible.size>0);}
    function registerTargets(){
      targets=Array.prototype.slice.call(document.querySelectorAll('body.template-index .fnx-c02-selector, body.template-product .fnx-science, body.template-product section.r07-related-dynamic'));
      if(!targets.length)return;
      if('IntersectionObserver' in window){
        var io=new IntersectionObserver(function(entries){
          entries.forEach(function(entry){if(entry.isIntersecting)visible.add(entry.target);else visible.delete(entry.target);});
          syncContext();
        },{root:null,rootMargin:'24px 0px 24px 0px',threshold:.01});
        targets.forEach(function(el){io.observe(el);});
      }else{
        var check=function(){
          visible.clear();
          var h=window.innerHeight||document.documentElement.clientHeight;
          targets.forEach(function(el){var r=el.getBoundingClientRect();if(r.bottom>0&&r.top<h)visible.add(el);});
          syncContext();
        };
        window.addEventListener('scroll',check,{passive:true});
        check();
      }
    }

    syncViewport();
    registerTargets();
    window.addEventListener('resize',syncViewport,{passive:true});
    window.addEventListener('orientationchange',syncViewport,{passive:true});
    if(window.visualViewport)window.visualViewport.addEventListener('resize',syncViewport,{passive:true});
  });
})();
;

/* FÉNIX 2.4 V23 HOME FOOTER 06 · nm-fenix-r07-ui-polish-v76.js */
/* FÉNIX R07.76 — footer social centering + explicit light/dark mode labels */
(function(){
  'use strict';

  function markSocial(){
    var footer=document.querySelector('footer.site-footer');
    if(!footer)return;
    var icons=footer.querySelector('.social-icons');
    var wrap=icons&&icons.closest?icons.closest('.grid__item'):null;
    if(wrap)wrap.classList.add('nm-footer-social-centered');
  }

  function currentTheme(){
    var root=document.documentElement;
    var value=root.getAttribute('data-nm-theme')||root.getAttribute('data-theme');
    return value==='light'?'light':'dark';
  }

  function syncThemeLabels(){
    var theme=currentTheme();
    var label=theme==='light'?'Modo oscuro':'Modo claro';
    var controls=document.querySelectorAll('.nm-theme-toggle');
    for(var i=0;i<controls.length;i++){
      var button=controls[i];
      button.setAttribute('title',label);
      button.setAttribute('aria-label',label);
      button.setAttribute('data-nm-mode-label',label);
      var children=button.children||[];
      for(var j=0;j<children.length;j++){
        var child=children[j];
        if(child.tagName==='SPAN'&&!child.classList.contains('nm-theme-icon')){
          if(child.textContent!==label)child.textContent=label;
        }
      }
    }
  }

  function init(){
    markSocial();
    syncThemeLabels();
    window.addEventListener('nm:themechange',function(){
      if(window.requestAnimationFrame){window.requestAnimationFrame(syncThemeLabels);}else{syncThemeLabels();}
    });
    window.addEventListener('pageshow',syncThemeLabels);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init,{once:true});
  }else{
    init();
  }
})();
;

/* FÉNIX 2.4 V23 HOME FOOTER 07 · nm-fenix-r07-mobile-ui-v85.js */
/* FÉNIX R07.86 — mobile interaction authority · catalog expand repair */
(function(){'use strict';
  function coarse(){
    return window.matchMedia('(max-width:760px)').matches ||
      (window.matchMedia('(max-width:1180px)').matches && window.matchMedia('(hover:none) and (pointer:coarse)').matches);
  }

  function isCollection(){
    return !!(document.body && document.body.classList.contains('template-collection'));
  }

  function prepareProductControls(){
    if(!coarse() || !isCollection()) return;
    document.querySelectorAll('.fnx43-expand').forEach(function(btn){
      var pressed=btn.getAttribute('aria-pressed')==='true';
      btn.setAttribute('aria-label',pressed?'Reducir producto':'Ampliar producto');
      btn.setAttribute('title',pressed?'Reducir':'Ampliar');
      btn.removeAttribute('data-fnx85-mobile-view');
      btn.style.pointerEvents='auto';
      btn.style.zIndex='30';
    });
  }

  function toggleCatalogCard(button){
    var item=button && button.closest ? button.closest('.grid__item') : null;
    var container=item && item.parentElement;
    if(!item || !container) return false;
    var cards=[].slice.call(container.querySelectorAll(':scope > .grid__item'));
    if(!cards.length) cards=[].slice.call(document.querySelectorAll('body.template-collection .grid-link__container>.grid__item'));
    var expanding=!item.classList.contains('is-fnx43-featured');

    cards.forEach(function(other){
      other.classList.remove('is-fnx43-featured');
      var otherButton=other.querySelector('.fnx43-expand');
      if(otherButton){
        otherButton.setAttribute('aria-pressed','false');
        otherButton.setAttribute('aria-label','Ampliar producto');
        otherButton.setAttribute('title','Ampliar');
        var otherLabel=otherButton.querySelector('span');
        if(otherLabel) otherLabel.textContent='Ampliar';
      }
    });

    if(expanding){
      item.classList.add('is-fnx43-featured');
      button.setAttribute('aria-pressed','true');
      button.setAttribute('aria-label','Reducir producto');
      button.setAttribute('title','Reducir');
      var label=button.querySelector('span');
      if(label) label.textContent='Reducir';
      if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
        window.setTimeout(function(){
          try{ item.scrollIntoView({behavior:'smooth',block:'nearest'}); }catch(_){ item.scrollIntoView(); }
        },30);
      }
    }
    return true;
  }

  /* R07.86: en móvil la lupa vuelve a hacer lo que fue diseñada para hacer:
     ampliar/reducir la tarjeta. Se resuelve aquí en capture para evitar carreras
     con enlaces estirados o con el listener desktop de v43. */
  document.addEventListener('click',function(event){
    if(!coarse() || !isCollection()) return;
    var target=event.target && event.target.closest ? event.target.closest('.fnx43-expand') : null;
    if(!target) return;
    event.preventDefault();
    event.stopPropagation();
    if(event.stopImmediatePropagation) event.stopImmediatePropagation();
    toggleCatalogCard(target);
  },true);

  /* Hardening de la lupa del header: v24 conserva la experiencia predictiva;
     solo si un toque que debía abrirla no produce estado abierto, cae a /search. */
  document.addEventListener('click',function(event){
    if(!coarse()) return;
    var trigger=event.target && event.target.closest ? event.target.closest('.nm-mobile-search-toggle,[data-nm-search-trigger]') : null;
    if(!trigger) return;
    var wasOpen=trigger.getAttribute('aria-expanded')==='true';
    if(wasOpen) return;
    window.setTimeout(function(){
      var panel=document.getElementById('nmSearchPanel');
      var opened=trigger.getAttribute('aria-expanded')==='true' || (panel && panel.getAttribute('aria-hidden')==='false');
      if(!opened) window.location.assign('/search');
    },180);
  },true);

  function init(){
    prepareProductControls();
    var root=document.querySelector('body.template-collection .grid-link__container');
    if(root && window.MutationObserver){
      new MutationObserver(function(){prepareProductControls();}).observe(root,{childList:true,subtree:true});
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  window.addEventListener('pageshow',prepareProductControls);
})();
;

/* FÉNIX 2.4 V23 HOME FOOTER 08 · nm-v70-9-floating-runtime.js */
(function(){"use strict";var MOBILE_MAX=989,PROOF_SELECTOR=["#prove-source-container","#provesource-container","#ps-container",'[id*="provesource"]','[class*="provesource"]','[id*="prove-source"]','[class*="prove-source"]','[id*="proofsource"]','[class*="proofsource"]','[id*="proof-source"]','[class*="proof-source"]','[id*="provesrc"]','[class*="provesrc"]',".ps-widget",".ps-notification",".provesrc-notification",'iframe[src*="provesource"]','iframe[src*="proofsource"]','iframe[title*="ProveSource"]'].join(","),CHAT_SELECTOR=["shopify-chat","#shopify-chat","#ShopifyChat",".shopify-chat",".shopify-chat--launcher",".shopify-inbox-launcher",".shopify-chat-launcher","#dummy-chat-button-iframe",'iframe[title*="Shopify Inbox"]','iframe[title*="chat"]','iframe[src*="shopify.com/chat"]','iframe[src*="inbox.shopify"]','iframe[src*="shopifyinbox"]'].join(","),observedTargets=new WeakSet,observedProofTargets=new WeakSet,frame=0;function isMobile(){return window.innerWidth<=MOBILE_MAX}function safeBottom(value){var pixels=Math.round(value)+"px";return isMobile()?"calc("+pixels+" + env(safe-area-inset-bottom, 0px))":pixels}function safeLeft(value){var pixels=Math.round(value)+"px";return isMobile()?"max("+pixels+", env(safe-area-inset-left, 0px))":pixels}function safeRight(value){var pixels=Math.round(value)+"px";return isMobile()?"max("+pixels+", env(safe-area-inset-right, 0px))":pixels}function isShopifyChatHost(el){return!!(el&&el.tagName&&el.tagName.toLowerCase()==="shopify-chat")}function viewportHeight(){return window.visualViewport&&window.visualViewport.height||window.innerHeight||document.documentElement.clientHeight||0}function setImportant(el,prop,value){!el||!el.style||(el.style.getPropertyValue(prop)!==value||el.style.getPropertyPriority(prop)!=="important")&&el.style.setProperty(prop,value,"important")}function visibleRect(el){if(!el||!el.getBoundingClientRect)return null;if(isShopifyChatHost(el)&&el.shadowRoot){var activator=el.shadowRoot.querySelector('[part="activator"]');if(activator)return activator.getBoundingClientRect()}return el.getBoundingClientRect()}function isVisible(el){if(!el||!el.getBoundingClientRect)return!1;if(isShopifyChatHost(el))return!0;var style=window.getComputedStyle(el);if(style.display==="none"||style.visibility==="hidden"||parseFloat(style.opacity||"1")===0)return!1;var rect=visibleRect(el);return!!(rect&&rect.width>0&&rect.height>0)}function queryAll(selector){try{return Array.prototype.slice.call(document.querySelectorAll(selector))}catch(error){return[]}}function topLevelVisible(nodes){var visible=nodes.filter(isVisible);return visible.filter(function(el){return!visible.some(function(candidate){return candidate!==el&&candidate.contains&&candidate.contains(el)})})}function firstVisible(selector){for(var nodes=queryAll(selector),i=0;i<nodes.length;i+=1)if(isVisible(nodes[i]))return nodes[i];return null}function getRailLeft(){var basis=firstVisible(".sidebar-module")||firstVisible(".site-header__logo");return basis?Math.max(20,Math.round(basis.getBoundingClientRect().left)):20}function stickyState(){var sticky=document.getElementById("nmStickyATC"),active=!1,height=0;if(isMobile()&&sticky){var style=window.getComputedStyle(sticky);active=sticky.classList.contains("is-visible")&&style.display!=="none"&&style.visibility!=="hidden",active&&(height=Math.ceil(sticky.getBoundingClientRect().height))}return document.documentElement.classList.toggle("nm-sticky-atc-active",active),document.documentElement.style.setProperty("--nm-sticky-atc-height",height+"px"),{active:active,height:height}}function widgetStack(sticky){if(!isMobile())return{fab:22,chat:20,proof:104};var safeBottom2=sticky.active?sticky.height+14:14,chatBottom=Math.max(82,safeBottom2+68);return{fab:safeBottom2,chat:chatBottom,proof:sticky.active?sticky.height+6:8}}function positionFab(stack){var fab=document.getElementById("nmChatFab");fab&&(setImportant(fab,"position","fixed"),setImportant(fab,"top","auto"),setImportant(fab,"right",isMobile()?"auto":"22px"),setImportant(fab,"left",isMobile()?safeLeft(14):"auto"),setImportant(fab,"bottom",safeBottom(stack.fab)),setImportant(fab,"z-index","2147482700"),fab.classList.remove("nm-fab-force-left"))}function positionProof(el,stack){isVisible(el)&&(setImportant(el,"position","fixed"),setImportant(el,"box-sizing","border-box"),setImportant(el,"top","auto"),setImportant(el,"bottom",safeBottom(stack.proof)),setImportant(el,"z-index","2147482400"),setImportant(el,"transition","bottom 240ms ease-out, opacity 200ms ease"),isMobile()?(setImportant(el,"left","auto"),setImportant(el,"right",safeRight(8)),setImportant(el,"max-width",Math.min(340,window.innerWidth-16)+"px")):(setImportant(el,"left","auto"),setImportant(el,"right","22px"),setImportant(el,"max-width","300px")))}function knownProofElements(){return{area:document.getElementById("provesrc-widget-area"),container:document.getElementById("provesrc-notification-container")}}function isInsideKnownProof(el,known){return!el||!known?!1:el===known.area||el===known.container||known.area&&known.area.contains&&known.area.contains(el)?!0:!!(known.container&&known.container.contains&&known.container.contains(el))}function observeKnownProof(el){if(!(!window.MutationObserver||!el||observedProofTargets.has(el))){observedProofTargets.add(el);var observer=new MutationObserver(schedule);observer.observe(el,{attributes:!0,attributeFilter:["class","style","view"],childList:!0,subtree:!0})}}function positionKnownProof(known,stack){var area=known.area,container=known.container;return area&&(setImportant(area,"position","fixed"),setImportant(area,"top","0px"),setImportant(area,"right","0px"),setImportant(area,"bottom","0px"),setImportant(area,"left","0px"),setImportant(area,"width","auto"),setImportant(area,"height","auto"),setImportant(area,"margin","0px"),setImportant(area,"transform","none"),setImportant(area,"overflow","visible"),setImportant(area,"pointer-events","none"),setImportant(area,"background","transparent"),setImportant(area,"border","0px"),setImportant(area,"box-shadow","none"),setImportant(area,"z-index","2147482400"),observeKnownProof(area)),container?(setImportant(container,"position","fixed"),setImportant(container,"box-sizing","border-box"),setImportant(container,"top","auto"),setImportant(container,"left","auto"),setImportant(container,"right",isMobile()?safeRight(8):"12px"),setImportant(container,"bottom",safeBottom(stack.proof)),setImportant(container,"width","fit-content"),setImportant(container,"max-width",isMobile()?Math.min(250,window.innerWidth-108)+"px":"clamp(212px, 18vw, 280px)"),setImportant(container,"min-width","0px"),setImportant(container,"height","auto"),setImportant(container,"margin","0px"),setImportant(container,"transform","none"),setImportant(container,"overflow","visible"),setImportant(container,"pointer-events","none"),setImportant(container,"background","transparent"),setImportant(container,"border","0px"),setImportant(container,"box-shadow","none"),setImportant(container,"z-index","2147482400"),setImportant(container,"transition","bottom 240ms ease-out, opacity 200ms ease"),observeKnownProof(container),!0):!!area}function positionShopifyHost(el,stack){setImportant(el,"display","grid"),setImportant(el,"position","fixed"),setImportant(el,"left","0px"),setImportant(el,"right","0px"),setImportant(el,"top","auto"),setImportant(el,"bottom","0px"),setImportant(el,"width","100%"),setImportant(el,"height","0px"),setImportant(el,"max-width","none"),setImportant(el,"overflow","visible"),setImportant(el,"z-index","2147482600"),setImportant(el,"--shopify-agent-activator-offset",safeBottom(stack.chat)),el.classList.add("nm-v709-shopify-chat")}function positionLegacyChat(el,stack){if(isVisible(el)){var viewportWidth=window.innerWidth||document.documentElement.clientWidth||0,viewportH=viewportHeight();if(!(!viewportWidth||!viewportH)){var rect=visibleRect(el),looksOpen=rect&&(rect.width>180||rect.height>120);if(setImportant(el,"position","fixed"),setImportant(el,"top","auto"),setImportant(el,"left",isMobile()?safeLeft(14):"22px"),setImportant(el,"right","auto"),setImportant(el,"bottom",safeBottom(stack.chat)),setImportant(el,"z-index","2147482600"),!!looksOpen){var maxHeight=Math.max(280,Math.floor(viewportH-stack.chat-8)),maxWidth=Math.max(280,Math.floor(viewportWidth-22));setImportant(el,"max-height",maxHeight+"px"),setImportant(el,"max-width",maxWidth+"px"),setImportant(el,"box-sizing","border-box")}}}}function positionChat(el,stack){if(isShopifyChatHost(el)){positionShopifyHost(el,stack);return}positionLegacyChat(el,stack)}function observeTarget(el){if(!(!window.MutationObserver||!el||observedTargets.has(el))){observedTargets.add(el);var observer=new MutationObserver(schedule);observer.observe(el,{attributes:!0,attributeFilter:["class","style","view"],childList:!0,subtree:!1})}}function run(){frame=0;var sticky=stickyState(),stack=widgetStack(sticky),knownProof=knownProofElements(),proofs=topLevelVisible(queryAll(PROOF_SELECTOR)).filter(function(el){return!isInsideKnownProof(el,knownProof)}),chats=topLevelVisible(queryAll(CHAT_SELECTOR)),stickyEl=document.getElementById("nmStickyATC");stickyEl&&observeTarget(stickyEl),positionKnownProof(knownProof,stack),proofs.forEach(function(el){observeTarget(el),positionProof(el,stack)}),chats.forEach(function(el){observeTarget(el),positionChat(el,stack)}),positionFab(stack),document.documentElement.classList.toggle("nm-shopify-chat-mounted",chats.some(isShopifyChatHost))}function schedule(){frame||(frame=window.requestAnimationFrame(run))}window.MutationObserver&&new MutationObserver(schedule).observe(document.documentElement,{childList:!0,subtree:!0}),window.addEventListener("load",schedule,{passive:!0}),window.addEventListener("resize",schedule,{passive:!0}),window.addEventListener("nm:sticky-atc-change",schedule),document.addEventListener("nm:provesource-ready",schedule),window.visualViewport&&window.visualViewport.addEventListener("resize",schedule,{passive:!0}),document.addEventListener("click",function(){window.setTimeout(schedule,80),window.setTimeout(schedule,350)},!0),[0,250,700,1500,3e3,5e3,8e3].forEach(function(delay){window.setTimeout(schedule,delay)})})();
;

/* FÉNIX 2.4 V23 HOME FOOTER 09 · fnx-r08-runtime-stability-v01.js */
/* FÉNIX R08.01 — runtime stability: one mobile-nav authority + state sync. */
(function(){
  'use strict';
  var root=document.documentElement;

  function detachLegacyMobileNav(){
    if(!window.jQuery)return;
    try{
      /* theme.js todavía registra slideToggle sobre estos mismos controles.
         Se retira sólo el handler jQuery; la autoridad nativa FÉNIX permanece. */
      window.jQuery('#MobileNavTrigger').off('click');
      window.jQuery('#MobileNav .mobile-nav__sublist-trigger').off('click');
      var nav=document.getElementById('MobileNav');
      if(nav){
        nav.style.removeProperty('display');
        nav.style.removeProperty('height');
        nav.style.removeProperty('padding-top');
        nav.style.removeProperty('padding-bottom');
      }
    }catch(e){}
  }

  function syncThemeLabels(){
    if(!root)return;
    var light=(root.getAttribute('data-nm-theme')||root.getAttribute('data-theme'))==='light';
    var label=light?'Modo oscuro':'Modo claro';
    document.querySelectorAll('.nm-theme-toggle').forEach(function(button){
      button.setAttribute('title',label);
      button.setAttribute('aria-label',label);
      var spans=button.querySelectorAll('span:not(.nm-theme-icon)');
      spans.forEach(function(span){ span.textContent=label; });
    });
  }

  function schedule(){
    detachLegacyMobileNav();
    syncThemeLabels();
    window.setTimeout(detachLegacyMobileNav,0);
    window.setTimeout(detachLegacyMobileNav,120);
    window.setTimeout(detachLegacyMobileNav,420);
  }

  if(root&&window.MutationObserver){
    new MutationObserver(function(){ syncThemeLabels(); }).observe(root,{attributes:true,attributeFilter:['data-nm-theme','data-theme']});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});else schedule();
  window.addEventListener('pageshow',schedule,{passive:true});
  document.addEventListener('shopify:section:load',schedule);
})();

/* FÉNIX R08.02 — MOBILE MENU HITBOX GUARD
   Si una autoridad histórica estira el enlace del logo sobre el área visual del
   hamburger, cancela la navegación a HOME y reenvía el gesto al botón real. */
(function(){
  'use strict';
  var root=document.documentElement;
  if(!root||root.dataset.fnxR08MenuHitboxGuard==='1')return;
  root.dataset.fnxR08MenuHitboxGuard='1';
  var redispatching=false;

  function mobile(){
    return !!(window.matchMedia&&window.matchMedia('(max-width:1140px)').matches);
  }

  function harden(){
    var trigger=document.getElementById('MobileNavTrigger');
    if(!trigger)return;
    trigger.setAttribute('type','button');
    trigger.setAttribute('aria-controls','MobileNav');
    trigger.style.setProperty('pointer-events','auto','important');
    trigger.style.setProperty('z-index','80','important');
    var header=trigger.closest&&trigger.closest('.nm-mobile-header');
    if(header){
      header.style.setProperty('position','relative','important');
      header.style.setProperty('z-index','50','important');
      header.style.setProperty('pointer-events','auto','important');
    }
  }

  function inside(rect,x,y){
    return rect&&rect.width>=24&&rect.height>=24&&x>=rect.left&&x<=rect.right&&y>=rect.top&&y<=rect.bottom;
  }

  /* Fallback de coordenadas: sólo actúa si el tap cayó físicamente dentro del
     rectángulo del botón pero otro elemento recibió el evento. */
  document.addEventListener('click',function(event){
    if(redispatching||!mobile())return;
    var target=event.target;
    if(target&&target.closest&&target.closest('#MobileNavTrigger'))return;
    var trigger=document.getElementById('MobileNavTrigger');
    if(!trigger)return;
    var rect=trigger.getBoundingClientRect();
    if(!inside(rect,event.clientX,event.clientY))return;

    event.preventDefault();
    event.stopPropagation();
    if(event.stopImmediatePropagation)event.stopImmediatePropagation();

    redispatching=true;
    try{ trigger.click(); }catch(e){}
    redispatching=false;
  },true);

  function schedule(){
    harden();
    window.setTimeout(harden,0);
    window.setTimeout(harden,160);
    window.setTimeout(harden,500);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});else schedule();
  window.addEventListener('pageshow',schedule,{passive:true});
  window.addEventListener('resize',harden,{passive:true});
  document.addEventListener('shopify:section:load',schedule);
})();
;

/* FÉNIX 2.4 V23 HOME FOOTER 10 · fnx-24-integral-authority-v01.js */
(function(){
  'use strict';

  var mediaSelector = [
    '.fnx-c02-card__visual img',
    '.nm-card-img-primary',
    '#ProductPhotoImg',
    '.r07-related__visual img'
  ].join(',');

  function retireAssistant(root){
    (root || document).querySelectorAll('#nmChatFab,#nmChatWidget,.nm-nootro-existing-launcher,[data-nootro-assistant],[data-nm-assistant]').forEach(function(node){
      node.remove();
    });
  }

  function protectImage(image){
    if(!image || image.nodeType !== 1){return;}
    image.dataset.fnx43Image = 'preserved';
    image.classList.remove('fnx43-cutout');
    image.classList.add('fnx24-media-safe');
    var source = (image.currentSrc || image.src || '').split('?')[0].toLowerCase();
    image.classList.toggle('fnx24-media-opaque', /\.(?:jpe?g)$/.test(source));
  }

  function protectMedia(root){
    (root || document).querySelectorAll(mediaSelector).forEach(protectImage);
  }

  function normalizeAddToCart(){
    var button = document.getElementById('AddToCart');
    var label = document.getElementById('AddToCartText');
    if(!button || !label || button.disabled){return;}
    label.textContent = 'Agregar al carrito';
  }

  function removeDuplicateLabels(){
    var duplicates = {
      'resumen rapido':true,
      'lo esencial en segundos':true,
      'informacion del producto':true,
      'profundiza cuando quieras':true
    };
    document.querySelectorAll('.fnx43-rich h1,.fnx43-rich h2,.fnx43-rich h3,.fnx43-rich h4,.fnx43-rich>p').forEach(function(node){
      var label = (node.textContent || '')
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g,'')
        .replace(/\s+/g,' ');
      if(duplicates[label]){node.classList.add('fnx24-duplicate-label');}
    });
  }

  function run(){
    retireAssistant(document);
    protectMedia(document);
    normalizeAddToCart();
    removeDuplicateLabels();
  }

  /* Run during parsing so the legacy canvas worker sees the preservation lock
     before its DOMContentLoaded callback can alter any Shopify image. */
  run();

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',run,{once:true});
  }

  document.addEventListener('change',function(event){
    if(event.target && (event.target.id === 'productSelect' || event.target.closest('.nm-variant-group'))){
      window.requestAnimationFrame(normalizeAddToCart);
    }
  },true);
  document.addEventListener('click',function(event){
    if(event.target && event.target.closest('.nm-chip')){
      window.requestAnimationFrame(normalizeAddToCart);
    }
  },true);

  if('MutationObserver' in window){
    var observer = new MutationObserver(function(records){
      records.forEach(function(record){
        record.addedNodes.forEach(function(node){
          if(!node || node.nodeType !== 1){return;}
          if(node.matches && node.matches(mediaSelector)){protectImage(node);}
          if(node.querySelectorAll){protectMedia(node);retireAssistant(node);}
        });
      });
    });
    observer.observe(document.documentElement,{childList:true,subtree:true});
  }
})();
;

/* FÉNIX 2.4 V23 HOME FOOTER 11 · fnx-24-visual-qa-v04.js */
(function(){
  'use strict';

  var labels = [
    'Contenido declarado',
    'Presentación',
    'Disponibilidad',
    'Marca'
  ];

  function forceCollectionGrid(){
    if(!document.body || !document.body.classList.contains('template-collection')){return;}
    var listActive = document.querySelector('.collection-view .change-view--active[data-view="list"]');
    var current = new URL(window.location.href);
    if(!listActive && current.searchParams.get('view') !== 'list'){return;}
    current.searchParams.set('view','grid');
    current.searchParams.delete('page');
    window.location.replace(current.toString());
  }

  function formatFact(node){
    if(!node || node.dataset.fnx24Fact === 'true'){return;}
    var text = (node.textContent || '').replace(/\s+/g,' ').trim();
    if(!text){return;}
    var label = labels.find(function(candidate){
      return text.toLocaleLowerCase('es').indexOf(candidate.toLocaleLowerCase('es')) === 0;
    });
    if(!label){return;}
    var value = text.slice(label.length).replace(/^\s*[:·–—-]?\s*/,'').trim();
    if(!value){return;}
    var labelNode = document.createElement('span');
    var valueNode = document.createElement('span');
    labelNode.className = 'fnx24-fact-label';
    valueNode.className = 'fnx24-fact-value';
    labelNode.textContent = label;
    valueNode.textContent = value;
    node.replaceChildren(labelNode,valueNode);
    node.dataset.fnx24Fact = 'true';
  }

  function removeRedundantAvailability(root){
    var scope = root || document;
    var nodes = [];
    if(scope.matches && scope.matches('[data-fnx24-section="intro"] .fnx-fact')){nodes.push(scope);}
    scope.querySelectorAll('[data-fnx24-section="intro"] .fnx-fact').forEach(function(node){nodes.push(node);});
    nodes.forEach(function(node){
      var text = (node.textContent || '').replace(/\s+/g,' ').trim().toLocaleLowerCase('es');
      if(text.indexOf('disponibilidad') === 0){node.remove();}
    });
  }

  function formatFacts(root){
    var scope = root || document;
    removeRedundantAvailability(scope);
    if(scope.matches && scope.matches('[data-fnx24-section="intro"] .fnx-fact')){formatFact(scope);}
    scope.querySelectorAll('[data-fnx24-section="intro"] .fnx-fact').forEach(formatFact);
  }

  function run(){
    forceCollectionGrid();
    formatFacts(document);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',run,{once:true});
  }else{
    run();
  }

  if('MutationObserver' in window){
    var observer = new MutationObserver(function(records){
      records.forEach(function(record){
        record.addedNodes.forEach(function(node){
          if(node && node.nodeType === 1){formatFacts(node);}
        });
      });
    });
    observer.observe(document.documentElement,{childList:true,subtree:true});
  }
})();
;

/* FÉNIX 2.4 V23 HOME FOOTER 12 · fnx-24-navigation-rescue-v07.js */
(function(){
  'use strict';

  function init(){
    var root=document.documentElement;
    var body=document.body;
    var nav=document.getElementById('MobileNav');
    var trigger=document.getElementById('MobileNavTrigger');
    var panel=document.getElementById('nmSearchPanel');
    if(!root||!body||root.dataset.fnx24NavigationRescue==='v07'){return;}
    root.dataset.fnx24NavigationRescue='v07';

    var lastSearchTrigger=null;

    function searchIsOpen(){
      return !!(panel&&(!panel.hidden||panel.classList.contains('is-open')||body.classList.contains('nm-search-open-v24')));
    }

    function menuIsOpen(){
      return !!(nav&&nav.classList.contains('is-visible'));
    }

    function syncSearch(){
      var open=searchIsOpen();
      if(panel){panel.setAttribute('aria-hidden',open?'false':'true');}
      document.querySelectorAll('.nm-search-toggle,.nm-mobile-search-toggle').forEach(function(button){
        button.setAttribute('aria-expanded',open?'true':'false');
      });
    }

    function syncMenu(){
      var open=menuIsOpen();
      if(nav){nav.setAttribute('aria-hidden',open?'false':'true');}
      if(trigger){trigger.setAttribute('aria-expanded',open?'true':'false');}
    }

    function closeSearch(restoreFocus){
      if(!panel){return;}
      panel.hidden=true;
      panel.classList.remove('is-open');
      body.classList.remove('nm-search-open-v24');
      root.classList.remove('nm-search-open-v24');
      syncSearch();
      if(restoreFocus&&lastSearchTrigger&&lastSearchTrigger.isConnected){
        window.requestAnimationFrame(function(){lastSearchTrigger.focus({preventScroll:true});});
      }
    }

    function closeSublists(){
      if(!nav){return;}
      nav.querySelectorAll('.mobile-nav__sublist-trigger').forEach(function(button){
        button.classList.remove('is-active');
        button.setAttribute('aria-expanded','false');
      });
      nav.querySelectorAll('.mobile-nav__sublist').forEach(function(list){
        list.classList.remove('is-nm-open');
        list.style.setProperty('--nm-r0733-sublist-h','0px');
      });
    }

    function closeMenu(restoreFocus){
      if(!nav){return;}
      var lockValue=parseFloat(root.style.getPropertyValue('--nm-mobile-menu-lock-y'))||0;
      var restoreY=Math.max(0,-lockValue);
      nav.classList.remove('is-visible');
      closeSublists();
      root.classList.remove('nm-mobile-menu-open');
      body.classList.remove('nm-mobile-menu-lock');
      root.style.removeProperty('--nm-mobile-menu-lock-y');
      syncMenu();
      if(lockValue){window.requestAnimationFrame(function(){window.scrollTo(0,restoreY);});}
      if(restoreFocus&&trigger){
        window.requestAnimationFrame(function(){trigger.focus({preventScroll:true});});
      }
    }

    document.addEventListener('pointerdown',function(event){
      var target=event.target instanceof Element?event.target:null;
      if(!target){return;}
      var searchButton=target.closest('.nm-search-toggle,.nm-mobile-search-toggle');
      if(searchButton){lastSearchTrigger=searchButton;}
      if(searchIsOpen()&&!target.closest('#nmSearchPanel')&&!searchButton){closeSearch(false);}
      if(menuIsOpen()&&!target.closest('#MobileNav')&&!target.closest('#MobileNavTrigger')){closeMenu(false);}
    },true);

    document.addEventListener('keydown',function(event){
      if(event.key!=='Escape'){return;}
      if(searchIsOpen()){
        event.preventDefault();
        closeSearch(true);
        return;
      }
      if(menuIsOpen()){
        event.preventDefault();
        closeMenu(true);
      }
    },true);

    if(panel&&'MutationObserver' in window){
      new MutationObserver(syncSearch).observe(panel,{attributes:true,attributeFilter:['class','hidden']});
    }
    if(nav&&'MutationObserver' in window){
      new MutationObserver(syncMenu).observe(nav,{attributes:true,attributeFilter:['class']});
    }

    window.addEventListener('pageshow',function(){
      closeSearch(false);
      closeMenu(false);
    },{passive:true});

    syncSearch();
    syncMenu();
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){window.setTimeout(init,0);},{once:true});
  }else{
    window.setTimeout(init,0);
  }
})();
;

/* FÉNIX 2.4 V23 HOME FOOTER 13 · fnx-24-release-closure-v08.js */
(function(){
  'use strict';

  function normalizeIntro(root){
    var scope = root || document;
    scope.querySelectorAll('[data-fnx24-section="intro"] .kicker').forEach(function(node){
      var text = (node.textContent || '').trim();
      if(/^ESTA PRESENTACIÓN\b/i.test(text)){
        node.textContent = text.replace(/^ESTA PRESENTACIÓN/i,'INTRODUCCIÓN');
      }
    });
  }

  function syncChipGroup(group){
    if(!group){return;}
    var selector = group.closest('form') && group.closest('form').querySelector('.single-option-selector');
    var selectedValue = selector ? selector.value : '';
    var chips = Array.prototype.slice.call(group.querySelectorAll('.nm-chip'));
    var activeChip = chips.find(function(chip){
      return chip.classList.contains('is-active') || (selectedValue && chip.dataset.value === selectedValue);
    }) || chips[0];
    chips.forEach(function(chip){
      var active = chip === activeChip;
      chip.setAttribute('role','radio');
      chip.setAttribute('aria-checked',active ? 'true' : 'false');
      chip.setAttribute('tabindex',active ? '0' : '-1');
    });
  }

  function enhanceVariants(root){
    var scope = root || document;
    scope.querySelectorAll('.nm-variant-group').forEach(function(group){
      if(group.dataset.fnx08Ready !== 'true'){
        group.dataset.fnx08Ready = 'true';
        group.setAttribute('role','radiogroup');
        var label = group.querySelector('.nm-variant-label');
        if(label){group.setAttribute('aria-label',(label.textContent || '').trim());}
        group.addEventListener('keydown',function(event){
          var chip = event.target.closest('.nm-chip');
          if(!chip || (event.key !== ' ' && event.key !== 'Enter')){return;}
          event.preventDefault();
          chip.click();
        });
      }
      syncChipGroup(group);
    });
  }

  function enhanceQuantities(root){
    var scope = root || document;
    scope.querySelectorAll('input[name="quantity"],input[name="updates[]"]').forEach(function(input){
      input.setAttribute('inputmode','numeric');
      input.setAttribute('pattern','[0-9]*');
    });
    scope.querySelectorAll('.js-qty__adjust--minus').forEach(function(button){
      if(!button.getAttribute('aria-label')){button.setAttribute('aria-label','Disminuir cantidad');}
    });
    scope.querySelectorAll('.js-qty__adjust--plus').forEach(function(button){
      if(!button.getAttribute('aria-label')){button.setAttribute('aria-label','Aumentar cantidad');}
    });
  }

  function enhanceFooter(root){
    var scope = root || document;
    scope.querySelectorAll('footer.site-footer .social-icons a').forEach(function(link){
      if(link.href && link.origin !== window.location.origin){
        link.setAttribute('target','_blank');
        link.setAttribute('rel','noopener noreferrer');
      }
    });
  }

  function run(root){
    document.documentElement.dataset.fnx24ReleaseClosure = 'v08';
    normalizeIntro(root);
    enhanceVariants(root);
    enhanceQuantities(root);
    enhanceFooter(root);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',function(){run(document);window.setTimeout(function(){run(document);},300);window.setTimeout(function(){run(document);},1200);},{once:true});
  }else{
    run(document);
    window.setTimeout(function(){run(document);},300);
    window.setTimeout(function(){run(document);},1200);
  }

  document.addEventListener('click',function(event){
    var chip = event.target.closest('.nm-chip');
    if(!chip){return;}
    window.setTimeout(function(){
      var group = chip.closest('.nm-variant-group');
      if(group){syncChipGroup(group);}
    },50);
  },true);

  document.addEventListener('change',function(event){
    if(!event.target.matches('.single-option-selector')){return;}
    var form = event.target.closest('form');
    if(form){form.querySelectorAll('.nm-variant-group').forEach(syncChipGroup);}
  },true);

  if('MutationObserver' in window){
    var observer = new MutationObserver(function(records){
      records.forEach(function(record){
        if(record.type === 'attributes' && record.target.classList && record.target.classList.contains('nm-chip')){
          syncChipGroup(record.target.closest('.nm-variant-group'));
          return;
        }
        record.addedNodes.forEach(function(node){
          if(node && node.nodeType === 1){run(node);}
        });
      });
    });
    observer.observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
  }
})();
;

/* FÉNIX 2.4 V23 HOME FOOTER 14 · fnx-24-mobile-checkout-closure-v09.js */
(function(){
  'use strict';

  function setImportant(node,property,value){
    if(node){node.style.setProperty(property,value,'important');}
  }

  function stabilizeBrand(root){
    var scope = root || document;
    var compact = window.matchMedia('(max-width:989px)').matches;
    var narrow = window.matchMedia('(max-width:390px)').matches;
    scope.querySelectorAll('.site-header .nm-fenix-brand').forEach(function(brand){
      setImportant(brand,'display','flex');
      setImportant(brand,'min-width',compact ? '0' : '190px');
      setImportant(brand,'align-items','center');
      setImportant(brand,'justify-content','flex-start');
      setImportant(brand,'filter','none');
    });
    scope.querySelectorAll('.site-header .nm-fenix-brand__mark,.site-header .nm-fenix-brand__copy').forEach(function(node){
      setImportant(node,'display','none');
    });
    scope.querySelectorAll('.site-header .nm-fenix-brand__seo-logo').forEach(function(image){
      setImportant(image,'position','static');
      setImportant(image,'display','block');
      setImportant(image,'width','auto');
      setImportant(image,'min-width','0');
      setImportant(image,'max-width',compact ? '100%' : '240px');
      var imageHeight = narrow ? '38px' : compact ? '44px' : '56px';
      setImportant(image,'height',imageHeight);
      setImportant(image,'min-height','0');
      setImportant(image,'max-height',imageHeight);
      setImportant(image,'margin','0');
      setImportant(image,'padding','0');
      setImportant(image,'overflow','hidden');
      setImportant(image,'clip','auto');
      setImportant(image,'-webkit-clip-path','inset(5px 2px 5px 2px round 999px)');
      setImportant(image,'clip-path','inset(5px 2px 5px 2px round 999px)');
      setImportant(image,'object-fit','cover');
      setImportant(image,'object-position','center');
      setImportant(image,'opacity','1');
      setImportant(image,'visibility','visible');
      setImportant(image,'transform','none');
      setImportant(image,'filter','none');
    });
  }

  function stabilizeTouchTargets(root){
    var scope = root || document;
    var selector = '.fnx-c02-card__bottom .fnx-c02-card__form > button,.fnx-c02-card__bottom .fnx-c02-card__form > a,.fnx-c02-card__bottom > a,footer.site-footer ul.social-icons li > a.icon-fallback-text';
    scope.querySelectorAll(selector).forEach(function(node){
      setImportant(node,'width','44px');
      setImportant(node,'min-width','44px');
      setImportant(node,'height','44px');
      setImportant(node,'min-height','44px');
    });
  }

  function enhanceCartConsent(root){
    var scope = root || document;
    var checkbox = scope.querySelector('#agree[required]') || document.querySelector('#agree[required]');
    var checkout = scope.querySelector('[name="checkout"]') || document.querySelector('[name="checkout"]');
    if(!checkbox || !checkout){return;}

    var terms = checkbox.closest('.nm-cart-terms') || checkbox.parentElement;
    if(terms && !terms.id){terms.id = 'fnx09-cart-consent';}
    if(terms){checkout.setAttribute('aria-describedby',terms.id);}

    function syncConsent(){
      var accepted = checkbox.checked === true;
      checkout.disabled = !accepted;
      checkout.setAttribute('aria-disabled',accepted ? 'false' : 'true');
      checkout.classList.toggle('is-disabled',!accepted);
      if(terms){terms.classList.toggle('is-accepted',accepted);}
    }

    if(checkbox.dataset.fnx09Ready !== 'true'){
      checkbox.dataset.fnx09Ready = 'true';
      checkbox.addEventListener('change',syncConsent);
      checkbox.addEventListener('input',syncConsent);
    }

    syncConsent();
  }

  function run(root){
    stabilizeBrand(root || document);
    stabilizeTouchTargets(root || document);
    enhanceCartConsent(root || document);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',function(){run(document);},{once:true});
  }else{
    run(document);
  }

  window.setTimeout(function(){run(document);},300);
  window.setTimeout(function(){run(document);},1200);
  window.addEventListener('pageshow',function(){run(document);});
  window.addEventListener('resize',function(){window.requestAnimationFrame(function(){run(document);});},{passive:true});
  document.addEventListener('shopify:section:load',function(event){run(event.target);});
})();
;

/* FÉNIX 2.4 V23 HOME FOOTER 15 · fnx-24-dual-theme-logo-v10.js */
(function(){
  'use strict';

  var root = document.documentElement;
  var selector = '.site-header .nm-fenix-brand__seo-logo[data-fnx-theme-logo]';

  function isLight(){
    return root.getAttribute('data-nm-theme') === 'light' || root.getAttribute('data-theme') === 'light' || root.classList.contains('nm-theme-light');
  }

  function setImportant(node,property,value){
    node.style.setProperty(property,value,'important');
  }

  function syncLogo(scope){
    var compact = window.matchMedia('(max-width:989px)').matches;
    var narrow = window.matchMedia('(max-width:390px)').matches;
    var width = narrow ? '152px' : compact ? '176px' : '240px';
    var height = narrow ? '38px' : compact ? '44px' : '56px';
    var key = isLight() ? 'fnxLogoLight' : 'fnxLogoDark';

    (scope || document).querySelectorAll(selector).forEach(function(image){
      var nextSource = image.dataset[key];
      if(nextSource && image.getAttribute('src') !== nextSource){image.setAttribute('src',nextSource);}
      image.classList.add('nm-fenix-brand__shopify-logo');
      image.dataset.fnxLogoCurrent = isLight() ? 'light' : 'dark';
      setImportant(image,'display','block');
      setImportant(image,'width',width);
      setImportant(image,'min-width',width);
      setImportant(image,'max-width',width);
      setImportant(image,'height',height);
      setImportant(image,'min-height',height);
      setImportant(image,'max-height',height);
      setImportant(image,'object-fit','cover');
      setImportant(image,'object-position','center');
      setImportant(image,'border-radius','999px');
      setImportant(image,'opacity','1');
      setImportant(image,'visibility','visible');
      setImportant(image,'transform','none');
      setImportant(image,'filter','none');
      setImportant(image,'transition','none');
    });
  }

  function run(){syncLogo(document);}

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',run,{once:true});
  }else{
    run();
  }

  new MutationObserver(function(records){
    if(records.some(function(record){return record.target === root;})){run();}
  }).observe(root,{attributes:true,attributeFilter:['data-nm-theme','data-theme','class']});

  window.addEventListener('pageshow',run);
  window.addEventListener('resize',function(){window.requestAnimationFrame(run);},{passive:true});
  document.addEventListener('shopify:section:load',run);
  window.setTimeout(run,300);
  window.setTimeout(run,1200);
})();
;

/* FÉNIX 2.4 V23 HOME FOOTER 16 · fnx-24-logo-transparency-v11.js */
(function(){
  'use strict';

  var selector = '.site-header .nm-fenix-brand__seo-logo[data-fnx-theme-logo]';

  function reveal(scope){
    (scope || document).querySelectorAll(selector).forEach(function(image){
      image.dataset.fnxTransparentReady = 'true';
      image.style.setProperty('opacity','1','important');
      image.style.setProperty('visibility','visible','important');
    });
  }

  reveal(document);
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',function(){reveal(document);},{once:true});
  }
  window.addEventListener('pageshow',function(){reveal(document);});
  document.addEventListener('shopify:section:load',function(event){reveal(event.target || document);});
})();
;

/* FÉNIX 2.4 V23 HOME FOOTER 17 · fnx-24-mobile-navigation-authority-v12.js */
(function(){
  'use strict';

  var root = document.documentElement;
  var nav = document.getElementById('MobileNav');
  var trigger = document.getElementById('MobileNavTrigger');
  var searchPanel = document.getElementById('nmSearchPanel');
  if(!nav || !trigger || root.dataset.fnx24MobileNavigation === 'v12'){return;}
  root.dataset.fnx24MobileNavigation = 'v12';

  var body = document.body;
  var restoreY = 0;
  var backdrop = document.querySelector('.fnx12-mobile-nav-backdrop');
  if(!backdrop){
    backdrop = document.createElement('button');
    backdrop.type = 'button';
    backdrop.className = 'fnx12-mobile-nav-backdrop';
    backdrop.hidden = true;
    backdrop.tabIndex = -1;
    backdrop.setAttribute('aria-label','Cerrar menú');
    body.appendChild(backdrop);
  }

  var closeButton = nav.querySelector('[data-nm-mobile-nav-close],.nm-mobile-nav-close');
  var sublistTrigger = nav.querySelector('.mobile-nav__sublist-trigger');
  var sublist = sublistTrigger && sublistTrigger.parentElement.querySelector('.mobile-nav__sublist');

  function menuIsOpen(){
    return nav.classList.contains('is-visible');
  }

  function closeSearch(){
    if(!searchPanel){return;}
    searchPanel.hidden = true;
    searchPanel.classList.remove('is-open');
    body.classList.remove('nm-search-open-v24');
    root.classList.remove('nm-search-open-v24');
    document.querySelectorAll('.nm-search-toggle,.nm-mobile-search-toggle').forEach(function(button){
      button.setAttribute('aria-expanded','false');
    });
  }

  function closeSublist(){
    if(!sublistTrigger || !sublist){return;}
    sublistTrigger.setAttribute('aria-expanded','false');
    sublist.classList.remove('is-nm-open','nm-sublist-open');
  }

  function openMenu(){
    if(menuIsOpen()){return;}
    closeSearch();
    restoreY = window.scrollY || window.pageYOffset || 0;
    root.style.setProperty('--nm-mobile-menu-lock-y',String(-restoreY) + 'px');
    nav.classList.add('is-visible');
    nav.setAttribute('aria-hidden','false');
    trigger.setAttribute('aria-expanded','true');
    backdrop.hidden = false;
    backdrop.classList.add('is-open');
    root.classList.add('nm-mobile-menu-open');
    body.classList.add('nm-mobile-menu-lock');
    window.requestAnimationFrame(function(){
      if(closeButton){closeButton.focus({preventScroll:true});}
    });
  }

  function closeMenu(restoreFocus){
    if(!menuIsOpen() && backdrop.hidden){return;}
    nav.classList.remove('is-visible');
    nav.setAttribute('aria-hidden','true');
    trigger.setAttribute('aria-expanded','false');
    backdrop.classList.remove('is-open');
    backdrop.hidden = true;
    root.classList.remove('nm-mobile-menu-open');
    body.classList.remove('nm-mobile-menu-lock');
    root.style.removeProperty('--nm-mobile-menu-lock-y');
    closeSublist();
    window.scrollTo(0,restoreY);
    if(restoreFocus){
      window.requestAnimationFrame(function(){trigger.focus({preventScroll:true});});
    }
  }

  function toggleSublist(){
    if(!sublistTrigger || !sublist){return;}
    var open = sublistTrigger.getAttribute('aria-expanded') === 'true';
    sublistTrigger.setAttribute('aria-expanded',open ? 'false' : 'true');
    sublist.classList.toggle('is-nm-open',!open);
    sublist.classList.toggle('nm-sublist-open',!open);
  }

  function syncThemeLabel(){
    var button = nav.querySelector('.nm-mobile-theme-toggle');
    if(!button){return;}
    var light = root.getAttribute('data-nm-theme') === 'light' || root.getAttribute('data-theme') === 'light';
    var label = light ? 'Modo oscuro' : 'Modo claro';
    button.dataset.nmThemeCurrent = light ? 'light' : 'dark';
    button.dataset.nmModeLabel = label;
    button.setAttribute('aria-label',light ? 'Cambiar a oscuro' : 'Cambiar a claro');
    button.setAttribute('title',light ? 'Cambiar a oscuro' : 'Cambiar a claro');
    var copy = button.querySelector('span:last-child');
    if(copy){copy.textContent = label;}
  }

  closeSublist();
  nav.setAttribute('aria-hidden','true');
  trigger.setAttribute('aria-expanded','false');
  if(sublistTrigger && sublist){
    if(!sublist.id){sublist.id = 'fnx12-mobile-goals';}
    sublistTrigger.setAttribute('aria-controls',sublist.id);
  }
  syncThemeLabel();

  document.addEventListener('click',function(event){
    var target = event.target instanceof Element ? event.target : null;
    if(!target){return;}

    if(target.closest('#MobileNavTrigger')){
      event.preventDefault();
      event.stopImmediatePropagation();
      menuIsOpen() ? closeMenu(false) : openMenu();
      return;
    }

    if(target.closest('[data-nm-mobile-nav-close],.nm-mobile-nav-close,.fnx12-mobile-nav-backdrop')){
      event.preventDefault();
      event.stopImmediatePropagation();
      closeMenu(true);
      return;
    }

    if(target.closest('#MobileNav .mobile-nav__sublist-trigger')){
      event.preventDefault();
      event.stopImmediatePropagation();
      toggleSublist();
      return;
    }

    if(target.closest('.nm-search-toggle,.nm-mobile-search-toggle')){
      closeMenu(false);
    }
  },true);

  document.addEventListener('keydown',function(event){
    if(event.key === 'Escape' && menuIsOpen()){
      event.preventDefault();
      event.stopImmediatePropagation();
      closeMenu(true);
    }
  },true);

  window.addEventListener('resize',function(){
    if(window.matchMedia('(min-width:990px)').matches){closeMenu(false);}
  },{passive:true});

  window.addEventListener('pageshow',function(){closeMenu(false);},{passive:true});
  new MutationObserver(syncThemeLabel).observe(root,{attributes:true,attributeFilter:['data-nm-theme','data-theme','class']});
})();
;

/* FÉNIX 2.4 V23 HOME FOOTER 18 · fnx-24-mobile-commerce-authority-v14.js */
(() => {
  const boot = () => {
    const body = document.body;
    if (!body?.classList.contains('template-product') || body.dataset.fnx14MobileCommerce === 'ready') return;
    const sticky = document.getElementById('nmStickyATC');
    const stickyButton = document.getElementById('nmStickyAdd');
    const nativeButton = document.getElementById('AddToCart');
    const price = document.getElementById('ProductPrice') || document.querySelector('.product-single__price');
    const title = document.querySelector('.nm-pdp-hero-copy__title, .product-single h1, main h1');
    const media = window.matchMedia('(max-width: 760px)');
    if (!sticky || !stickyButton || !nativeButton) return;
    body.dataset.fnx14MobileCommerce = 'ready';
    body.classList.add('fnx14-mobile-commerce-ready');
    sticky.setAttribute('aria-hidden', 'true');
    const stickyTitle = sticky.querySelector('[data-nm-sticky-title]');
    const stickyPrice = sticky.querySelector('[data-nm-sticky-price]');
    const sync = () => {
      if (stickyTitle && title) stickyTitle.textContent = title.textContent.trim();
      if (stickyPrice && price) stickyPrice.textContent = price.textContent.trim();
      const disabled = nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true';
      stickyButton.disabled = disabled;
      stickyButton.setAttribute('aria-disabled', String(disabled));
      stickyButton.textContent = nativeButton.textContent.trim() || (disabled ? 'Agotado' : 'Agregar al carrito');
    };
    const setVisible = visible => {
      const next = Boolean(visible && media.matches);
      sticky.classList.toggle('is-fnx14-visible', next);
      sticky.setAttribute('aria-hidden', String(!next));
      body.classList.toggle('fnx14-sticky-visible', next);
    };
    const updateVisibility = () => {
      const rect = nativeButton.getBoundingClientRect();
      setVisible(rect.bottom < 0);
    };
    stickyButton.addEventListener('click', event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      sync();
      if (!stickyButton.disabled) nativeButton.click();
    }, true);
    document.addEventListener('change', event => {
      if (event.target.matches('select, input[type="radio"], input[type="number"]')) {
        window.setTimeout(() => { sync(); updateVisibility(); }, 80);
      }
    });
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility, { passive: true });
    media.addEventListener?.('change', updateVisibility);
    if (window.MutationObserver) {
      new MutationObserver(sync).observe(nativeButton, { attributes: true, childList: true, subtree: true, attributeFilter: ['disabled', 'aria-disabled'] });
      if (price) new MutationObserver(sync).observe(price, { childList: true, subtree: true });
    }
    sync();
    updateVisibility();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
;
